import { render, staticRenderFns } from "./field-value.vue?vue&type=template&id=9fc6f258&scoped=true&"
import script from "./field-value.vue?vue&type=script&lang=ts&"
export * from "./field-value.vue?vue&type=script&lang=ts&"
import style0 from "./field-value.vue?vue&type=style&index=0&id=9fc6f258&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc6f258",
  null
  
)

export default component.exports